export default __webpack_public_path__ + "static/media/meals-bg.2e7289b8.png";